import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  btnCollapseExpand: {
    flexDirection: 'row',
    paddingLeft: 16,
    paddingRight: 16,
    paddingVertical: 12,
  },
  collapsibleContainer: {
    borderRadius: 12,
    marginBottom: 10,
    marginHorizontal: 16,
  },
});
export default styles;
